<router-outlet></router-outlet>
<app-toast></app-toast>

<!-- Componente invisibile per aggiornamenti automatici Service Worker -->
<app-service-worker-update></app-service-worker-update>

<!-- Modale offline non rimovibile, al momento sospesa
<app-modal
  [isOpen]="isOfflineModalOpen"
  [isRemovable]="false"
  [closeOnClickOutside]="false"
  title="{{ 'generic.connection.offline_title' | translate }}"
  description="{{ 'generic.connection.checking' | translate }}"
  actionButtonText="{{ 'generic.connection.retry' | translate }}"
  (onAction)="testConnection()"
  width="450px">
  
  <div class="text-center mt-3">
    <div class="spinner-border" role="status">
    </div>
  </div>
</app-modal>
-->